export default __webpack_public_path__ + "static/media/aave-logo.9c7c668c.png";